<span class="site-date-filter-menu">
  <button [matMenuTriggerFor]="dateMenu" [ngClass]="{'btn-filter-active': dateFilterBtnActive}" mat-stroked-button color="accent" class="btn-filter" ><span [innerHTML]="'$common_date' | translate"></span></button>
  <mat-menu #dateMenu="matMenu" class="filter-menu" [class]="isSpanish ? 'filter-custome-menu-es filter-menu' : 'filter-menu'">
    <mat-icon class="close-filter link">close</mat-icon>
    <div class="filter-menu-content" (click) = "$event.stopPropagation()">
      <form [formGroup]="filterDateFormGroup">
        <h5 class="no-margin" [innerHTML]="'$site_filter_date_title' | translate"></h5>
        <p>
          <mat-form-field class="form-field form-full-width-field">
            <mat-label [innerHTML]="'$lng_adm_sdt' | translate"></mat-label>
            <input formControlName="fromDateControl" matInput [matDatepicker]="fromDatePicker">
            <mat-datepicker-toggle matSuffix [for]="fromDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #fromDatePicker></mat-datepicker>
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="form-field form-full-width-field">
            <mat-label [innerHTML]="'$lng_adm_edt' | translate"></mat-label>
            <input formControlName="toDateControl" matInput [matDatepicker]="toDatePicker">
            <mat-datepicker-toggle matSuffix [for]="toDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #toDatePicker></mat-datepicker>
          </mat-form-field>
        </p>
      </form>
      <div class="row actions">
        <div class="col-xs"><button mat-button class="link clear-filters" (click)="clearDateFilter()" [innerHTML]="'$site_filter_reset_button' | translate"></button></div>
        <div class="col-xs end-xs"><button mat-button class="link" (click)="dateFilterActive()" [innerHTML]="'$site_filter_apply_button' | translate"></button></div>
      </div>
    </div>
  </mat-menu>
</span>
